// VideoPlayer.js
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { Grid, Card, Stack, Button, Typography, Box, Container, TextField, Select, MenuItem, FormControl, InputLabel, Divider } from '@mui/material';



const VideoPlayer = ({ sourceURL ,isView}) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);


    const togglePlay = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    /* eslint-disable jsx-a11y/media-has-caption */

    return (
        <div>
            <video ref={videoRef} width="100%" height="400" controls controlsList="nodownload">
                <source
                    src={isView ? sourceURL : URL.createObjectURL(sourceURL[0])}
                    type="video/mp4"
                />
                <track
                    label="English"
                    kind="subtitles"
                    srcLang="en"
                    src={isView ? sourceURL : URL.createObjectURL(sourceURL[0])}
                    default
                />
                Your browser does not support the video tag.
            </video>
            {/* <button onClick={togglePlay}>   */}
            {/*    {isPlaying ? 'Pause' : 'Play'}   */}
                {/* </button>    */}

        </div>
    );
};
VideoPlayer.propTypes = {

    sourceURL: PropTypes.array,
    isView: PropTypes.bool,
};
export default VideoPlayer;
